exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".enabled-button {\n  color: #4b81b0; }\n\n.disabled-button {\n  color: #9e9e9e; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/mercado/new-edit-mercado-dialog/new-edit-mercado-dialog.component.scss
// module id = ../../../../../src/app/components/abm/mercado/new-edit-mercado-dialog/new-edit-mercado-dialog.component.scss
// module chunks = 0